import { Button, PageHeader } from 'components';
import { Row, Col, Table, Checkbox } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useEditInvoices from './useEditInvoices';
import useUser from 'hooks/useUser';

const Edit = ({ isNew }) => {
  const { user } = useUser();
  const isAdmin = user?.user?.superadmin || user?.user?.master_admin;

  const {
    data,
    columns,
    tableSummary,
    onUpdate,
    updateInProcess,
    isWeekClosed,
    initialWeekClosed,
    setIsWeekClosed,
  } = useEditInvoices({ isAdmin });

  const taxableInputs = document.querySelectorAll('input[name="taxable"]');

  Array.from(taxableInputs).forEach((input, index) => {
    input.addEventListener('click', function () {
      if (this.value === '0,0') {
        this.value = '';
      }
    });
  });
  const { t } = useTranslation();
  const title = isNew
    ? t('PUBBLICA DOCUMENTO').toUpperCase()
    : t('MODIFICA DATI').toUpperCase();

  return (
    <div>
      <PageHeader title={title}>
        <Checkbox
          name='week_closed'
          checked={isWeekClosed}
          onChange={() => setIsWeekClosed(!isWeekClosed)}
          disabled={initialWeekClosed && !isAdmin}
        >
          {t('Chiudere la settimana')}
        </Checkbox>
      </PageHeader>
      <div className={styles.content}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          size='small'
          summary={tableSummary}
          rowKey='id'
          loading={updateInProcess}
          scroll={{ x: 1000 }}
        />
      </div>
      <Row className={styles.footer}>
        <Col>
          <Button
            onClick={onUpdate}
            width={'150px'}
            big
            icon={<CheckOutlined />}
            loading={updateInProcess}
            disabled={initialWeekClosed && !isAdmin}
          >
            {t('Invia')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Edit;
